<template>
  <div class="Menu-navigation">
    <div class="Menu-navigation__item"
         :class="isActiveMenuItem(PATHS_NAME.CALENDAR) ? ACTIVE_MENU_ITEM_CLASS : ''"
         @click="activeCalendarPage">
      <div class="Menu-navigation__icon">
        <CalendarIcon/>
      </div>
      <p class="Menu-navigation__text">Календарь</p>
    </div>
    <div class="Menu-navigation__item"
         :class="isActiveMenuItem(PATHS_NAME.FORECASTERS) ? ACTIVE_MENU_ITEM_CLASS : ''"
         @click="activeForecastersPage">
      <div class="Menu-navigation__icon">
        <ForecasterIcon/>
      </div>
      <p class="Menu-navigation__text">Форкастеры</p>
    </div>
    <div class="Menu-navigation__item"
         :class="isActiveMenuItem(PATHS_NAME.SIGNALS) ? ACTIVE_MENU_ITEM_CLASS : ''"
         @click="activeSignalsPage">
      <div class="Menu-navigation__icon">
        <SignalIcon/>
      </div>
      <p class="Menu-navigation__text">Сигналы</p>
    </div>
    <div class="Menu-navigation__item"
        :class="isActiveMenuItem(PATHS_NAME.SCANNER) ? ACTIVE_MENU_ITEM_CLASS : ''"
        @click="activeScreanerPage">
      <div class="Menu-navigation__icon">
        <ScreanerIcon/>
      </div>
      <p class="Menu-navigation__text">Скринер</p>
    </div>
    <div class="Menu-navigation__item"
        :class="isActiveMenuItem(PATHS_NAME.POLYMARKET) ? ACTIVE_MENU_ITEM_CLASS : ''"
        @click="activePolymarketPage">
      <div class="Menu-navigation__icon">
        <PolymarketIcon/>
      </div>
      <p class="Menu-navigation__text">Предикшены</p>
    </div>
    <div class="Menu-navigation__item"

         @click="toOpenSearch">
      <div class="Menu-navigation__icon">
        <SearchIcon/>
      </div>
      <p class="Menu-navigation__text">Поиск</p>
    </div>
    <CallBriefcaseDropdownItem class="Menu-navigation__briefcase" />
  </div>
</template>

<script setup>
import CalendarIcon from '@svg/navigation/CalendarIcon.vue';
import ForecasterIcon from "@svg/navigation/ForecasterIcon.vue";
import SignalIcon from "@svg/navigation/SignalIcon.vue";
import ScreanerIcon from "@svg/navigation/ScreanerIcon.vue";
import SearchIcon from "@svg/navigation/SearchIcon.vue";
import PolymarketIcon from '@shared/UI/Svg/context/Polymarket.vue';
import CallBriefcaseDropdownItem from '@/Groups/Briefcase/public/modules/CallBriefcaseDropdownItem/CallBriefcaseDropdownItem.vue';
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
import {PATHS_NAME} from '@shared/routers/consts/pathsName';

const route = useRoute();
const router = useRouter();
const store = useStore();

const ACTIVE_MENU_ITEM_CLASS = 'Menu-navigation__item--active';

const isActiveMenuItem = (routeName) => route.name === routeName;
//Открыть виджет поиска
const toOpenSearch = () => {
  store.dispatch('Dropdowns/addNewDropdown', DROPDOWN_NAMES.search);
}
//Открыть страницу календарь
const activeCalendarPage = () => router.push({name: PATHS_NAME.CALENDAR});
//Открыть страницу форкастеры
const activeForecastersPage = () => router.push({name: PATHS_NAME.FORECASTERS});
//Открыть страницу сигналов
const activeSignalsPage = () => router.push({name: PATHS_NAME.SIGNALS});
//Открыть страницу скриннера
const activeScreanerPage = () => router.push({name: PATHS_NAME.SCANNER});
//Открыть страницу полимаркета
const activePolymarketPage = () => router.push({name: PATHS_NAME.POLYMARKET});
</script>

<style scoped lang="scss">
@import './styles/_styles';
</style>
